import { render, staticRenderFns } from "./detailThreadInput.vue?vue&type=template&id=5d2a4cac&scoped=true&lang=pug"
import script from "./detailThreadInput.vue?vue&type=script&lang=js"
export * from "./detailThreadInput.vue?vue&type=script&lang=js"
import style0 from "./detailThreadInput.vue?vue&type=style&index=0&id=5d2a4cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a4cac",
  null
  
)

export default component.exports